import { useEffect, useRef, useState } from 'react'

export interface INumberPickerProps {
	data?: any,
	active?: string,
	setActive: (val: string) => void
}

const options = [
	{label: 'Last 12 months', value: ''},
	{label: 'Any date', value: 'false'},
]

const NumberPicker = ({ data, active, setActive }: INumberPickerProps) => {

	return (
		<div>
			<div className="listing-filter-picker">
				{options?.map((item, index) => (
					<button
						key={index}
						className={[active == item.value ? 'active' : '', (!active && index == 0 ? 'active' : '')].join(' ')}
						onClick={() => setActive(item.value)}
					>
						{item?.label}
					</button>
				))}
			</div>
		</div>
	)
}

export default NumberPicker
